import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { offlinePost } from '../services/api';
import api from '../services/api';
import { trackEvent } from '../services/analytics';
import { fetchInsightProgress } from '../utils/insightProgress';
import { getProgressMessage } from '../utils/insightReadiness';
/* Camera SVG icon for Log Meal button */
/* Camera icon for Log Meal */
const MealIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);

/* Poop icon — classic coil shape */
const PoopIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="20" rx="7" ry="3" fill="white"/>
    <ellipse cx="12" cy="16.5" rx="5.5" ry="2.5" fill="white"/>
    <ellipse cx="12" cy="13.5" rx="4" ry="2" fill="white"/>
    <path d="M11 7c-1 0-2 .8-2 2s1.5 2 3 2 3 .8 3 2" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

/* ── Symptom SVG Icons ── */
const SymptomIcons = {
  bloating: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="8" cy="8" r="6" />
      <circle cx="5.5" cy="7" r="0.8" fill="#4A2E1F" stroke="none" />
      <circle cx="10.5" cy="7" r="0.8" fill="#4A2E1F" stroke="none" />
      <path d="M6 10.5c0.5 0.8 1.2 1 2 1s1.5-0.2 2-1" />
    </svg>
  ),
  cramps: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 8l2.5-5 2.5 5 2.5-5 2.5 5" />
      <line x1="3" y1="12" x2="13" y2="12" />
    </svg>
  ),
  gas: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
      <path d="M4 12c0-3 2-4 2-6s-1-3-1-3" />
      <path d="M8 12c0-3 2-4 2-6s-1-3-1-3" />
      <path d="M12 12c0-3 2-4 2-6s-1-3-1-3" />
    </svg>
  ),
  nausea: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="8" cy="8" r="6" />
      <circle cx="5.5" cy="7" r="0.8" fill="#4A2E1F" stroke="none" />
      <circle cx="10.5" cy="7" r="0.8" fill="#4A2E1F" stroke="none" />
      <path d="M6 11c0.5-0.8 1.2-1 2-1s1.5 0.2 2 1" />
    </svg>
  ),
  urgency: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12l3-8 3 8" />
      <line x1="6" y1="10" x2="10" y2="10" />
      <line x1="8" y1="1" x2="8" y2="3" />
      <line x1="12" y1="3" x2="10.5" y2="4.5" />
      <line x1="4" y1="3" x2="5.5" y2="4.5" />
    </svg>
  ),
  fatigue: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
      <circle cx="8" cy="9" r="5.5" />
      <path d="M6 8h1.5" />
      <path d="M9 8h1.5" />
      <path d="M7 11h2" />
      <path d="M3 3.5L5 5" />
      <path d="M13 3.5L11 5" />
    </svg>
  ),
  blood: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 2C8 2 4 7 4 10a4 4 0 0 0 8 0c0-3-4-8-4-8z" fill="#B8564A" />
    </svg>
  ),
  mucus: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 2C8 2 4 7 4 10a4 4 0 0 0 8 0c0-3-4-8-4-8z" fill="#4A2E1F" opacity="0.3" stroke="#4A2E1F" strokeWidth="1" />
    </svg>
  ),
};

const SYMPTOM_OPTIONS = [
  { val: 'bloating', label: 'Bloating' },
  { val: 'cramps', label: 'Cramps' },
  { val: 'gas', label: 'Gas' },
  { val: 'nausea', label: 'Nausea' },
  { val: 'urgency', label: 'Urgency' },
  { val: 'fatigue', label: 'Fatigue' },
  { val: 'mucus', label: 'Mucus' },
];

const BLOOD_LEVELS = [
  { val: 'none', label: 'None' },
  { val: 'traces', label: 'Traces' },
  { val: 'mixed', label: 'Mixed' },
  { val: 'mostly_blood', label: 'Mostly Blood' },
];


function getNowDatetimeLocal() {
  const d = new Date();
  return d.getFullYear() + '-' +
    String(d.getMonth() + 1).padStart(2, '0') + '-' +
    String(d.getDate()).padStart(2, '0') + 'T' +
    String(d.getHours()).padStart(2, '0') + ':' +
    String(d.getMinutes()).padStart(2, '0');
}

const BRISTOL_TYPES = [
  { val: '1', label: 'Hard lumps' },
  { val: '2', label: 'Lumpy' },
  { val: '3', label: 'Cracked' },
  { val: '4', label: 'Smooth' },
  { val: '5', label: 'Soft blobs' },
  { val: '6', label: 'Mushy' },
  { val: '7', label: 'Liquid' },
];

const BRISTOL_ICONS = {
  '1': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <circle cx="6" cy="6" r="3" fill="#8B7355"/>
      <circle cx="15" cy="5" r="3.5" fill="#8B7355"/>
      <circle cx="24" cy="7" r="3" fill="#8B7355"/>
      <circle cx="10" cy="15" r="3" fill="#8B7355"/>
      <circle cx="20" cy="15" r="3.5" fill="#8B7355"/>
    </svg>
  ),
  '2': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <ellipse cx="14" cy="10" rx="12" ry="6" fill="#8B7355"/>
      <circle cx="7" cy="7" r="2.5" fill="#7A6345"/>
      <circle cx="14" cy="6" r="2.5" fill="#7A6345"/>
      <circle cx="21" cy="7" r="2.5" fill="#7A6345"/>
    </svg>
  ),
  '3': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <rect x="2" y="5" width="24" height="10" rx="5" fill="#8B7355"/>
      <line x1="9" y1="6" x2="9" y2="10" stroke="#6B5340" strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="14" y1="6" x2="14" y2="9" stroke="#6B5340" strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="19" y1="6" x2="19" y2="10" stroke="#6B5340" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  ),
  '4': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <rect x="2" y="6" width="24" height="8" rx="4" fill="#8B7355"/>
    </svg>
  ),
  '5': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <ellipse cx="7" cy="9" rx="5" ry="4" fill="#8B7355"/>
      <ellipse cx="20" cy="8" rx="6" ry="4.5" fill="#8B7355"/>
      <ellipse cx="13" cy="16" rx="5" ry="3" fill="#8B7355"/>
    </svg>
  ),
  '6': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <path d="M3 12c0-3 2-6 5-7 2-1 4 0 6 0s4-1 6 0c3 1 5 4 5 7s-3 5-11 5-11-2-11-5z" fill="#8B7355" opacity="0.85"/>
    </svg>
  ),
  '7': (
    <svg width="28" height="20" viewBox="0 0 28 20">
      <path d="M7 7c1.5-4 3-6 4-6s2 3 2.5 6c.8 4.5-1 8-3.5 8S5.5 11.5 7 7z" fill="#C4A24C" opacity="0.75"/>
      <path d="M18 5c1-3 2.5-4.5 3.5-4.5s1.5 2 2 4.5c.8 3.5-.5 7-2.5 7S17 8.5 18 5z" fill="#C4A24C" opacity="0.75"/>
    </svg>
  ),
};

/* ── Daily Summary Icons ── */
/* Fork + spoon icon for meals summary */
const MealSummaryIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7E8B47" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {/* Fork */}
    <line x1="7" y1="2" x2="7" y2="22"/>
    <line x1="4" y1="2" x2="4" y2="8"/>
    <line x1="10" y1="2" x2="10" y2="8"/>
    <line x1="4" y1="8" x2="10" y2="8"/>
    {/* Spoon */}
    <ellipse cx="17" cy="5" rx="3" ry="4"/>
    <line x1="17" y1="9" x2="17" y2="22"/>
  </svg>
);

/* Simple poop swirl for summary */
const PoopSummaryIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="#C4783C" stroke="none">
    <ellipse cx="12" cy="19.5" rx="6.5" ry="2.8"/>
    <ellipse cx="12" cy="15.5" rx="5" ry="2.3"/>
    <ellipse cx="12" cy="12" rx="3.5" ry="1.8"/>
    <path d="M13.5 6c0 0 1.5 1 1.5 2.5S13.5 11 13.5 11" fill="none" stroke="#C4783C" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

function DailySummary() {
  const [stats, setStats] = useState(null);
  const [mealNames, setMealNames] = useState([]);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        let todayStats;
        let names = [];
        const today = new Date().toISOString().split('T')[0];
        try {
          const res = await api.get(`/history?date=${today}`);
          const entries = res.data || [];
          todayStats = {
            mealsCount: entries.filter(e => e.type === 'meal').length,
            poopsCount: entries.filter(e => e.type === 'poop').length,
          };
          names = entries
            .filter(e => e.type === 'meal')
            .flatMap(e => (e.foods || []).map(f => f.name))
            .filter(Boolean);
        } catch {
          todayStats = { mealsCount: 0, poopsCount: 0 };
        }
        if (!cancelled) {
          setStats(todayStats);
          setMealNames(names);
        }
      } catch {
        if (!cancelled) setStats({ mealsCount: 0, poopsCount: 0 });
      }

      try {
        const prog = await fetchInsightProgress();
        if (!cancelled) setProgress(prog);
      } catch {
        // ignore
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  if (!stats) return null;

  const isEmpty = stats.mealsCount === 0 && stats.poopsCount === 0;
  const showProgress = progress && !progress.hasAnalyzed;
  const totalNeeded = 15;
  const current = showProgress ? (progress.mealsCount + progress.poopsCount + progress.daysCovered) : 0;
  const pct = showProgress ? Math.min(100, Math.round((current / totalNeeded) * 100)) : 0;

  const hasHistoricalData = progress && (progress.mealsCount > 0 || progress.poopsCount > 0);

  if (isEmpty) {
    return (
      <div className="daily-summary-card empty-state-card" style={{ textAlign: 'center', padding: '20px 24px' }}>
        <p style={{ fontSize: '16px', fontWeight: 600, color: '#4A2E1F', margin: '0 0 4px' }}>
          {hasHistoricalData ? 'Nothing logged today' : 'Ready when you are'}
        </p>
        <p style={{ fontSize: '14px', color: '#7A5A44', margin: 0 }}>
          {hasHistoricalData
            ? 'Log your meals and poops to keep tracking patterns'
            : <>Tap <strong>Log Meal</strong> to snap your first photo</>}
        </p>
      </div>
    );
  }

  return (
    <div className="daily-summary-card">
      <div className="daily-summary-row">
        <div className="daily-summary-stat">
          <MealSummaryIcon />
          <span className="daily-summary-num">{stats.mealsCount}</span>
          <span className="daily-summary-label">{stats.mealsCount === 1 ? 'meal' : 'meals'}</span>
        </div>
        <div className="daily-summary-divider" />
        <div className="daily-summary-stat">
          <PoopSummaryIcon />
          <span className="daily-summary-num">{stats.poopsCount}</span>
          <span className="daily-summary-label">{stats.poopsCount === 1 ? 'poop' : 'poops'}</span>
        </div>
      </div>
      {mealNames.length > 0 && (
        <div className="today-meals-row">
          {mealNames.map((name, i) => (
            <span key={i} className="today-meal-chip">{name}</span>
          ))}
        </div>
      )}
      {showProgress && (
        <div className="daily-summary-progress">
          <div className="daily-summary-progress-label" style={pct >= 100 ? { color: 'var(--accent-green)', fontWeight: 700 } : undefined}>
            {pct < 100 ? `${pct}% to first insight` : 'Ready for insights!'}
          </div>
          <div className="daily-summary-progress-bar">
            <div className="daily-summary-progress-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Daily Check-in Icons ── */
const StressIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
    <circle cx="8" cy="8" r="6" />
    <path d="M5 6l1.5 1" /><path d="M11 6l-1.5 1" />
    <path d="M5.5 11c.8-.8 1.5-1.2 2.5-1.2s1.7.4 2.5 1.2" />
  </svg>
);

const SleepIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
    <path d="M13 8.5a5.5 5.5 0 1 1-5.5-5.5c-1.5 2 0 5 2.5 6s4 .5 3-.5z" />
  </svg>
);

const WaterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
    <path d="M8 2C8 2 4 7 4 10a4 4 0 0 0 8 0c0-3-4-8-4-8z" />
  </svg>
);

const ExerciseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 8h2l2-4 4 8 2-4h2" />
  </svg>
);

const AlcoholIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
    <path d="M5 2h6l-1 5H6L5 2z" /><line x1="8" y1="7" x2="8" y2="12" /><line x1="5" y1="12" x2="11" y2="12" />
  </svg>
);

const MedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#4A2E1F" strokeWidth="1.5" strokeLinecap="round">
    <rect x="4" y="4" width="8" height="8" rx="1" /><line x1="8" y1="6" x2="8" y2="10" /><line x1="6" y1="8" x2="10" y2="8" />
  </svg>
);

const CHECKIN_SECTIONS = [
  {
    key: 'stressLevel',
    label: 'Stress',
    icon: <StressIcon />,
    options: [
      { val: 'low', label: 'Low' },
      { val: 'medium', label: 'Medium' },
      { val: 'high', label: 'High' },
    ],
  },
  {
    key: 'sleepQuality',
    label: 'Sleep',
    icon: <SleepIcon />,
    options: [
      { val: 'great', label: 'Great' },
      { val: 'ok', label: 'OK' },
      { val: 'bad', label: 'Bad' },
    ],
  },
  {
    key: 'hydration',
    label: 'Water',
    icon: <WaterIcon />,
    options: [
      { val: 'good', label: 'Good' },
      { val: 'low', label: 'Low' },
    ],
  },
  {
    key: 'exerciseLevel',
    label: 'Exercise',
    icon: <ExerciseIcon />,
    options: [
      { val: 'none', label: 'None' },
      { val: 'light', label: 'Light' },
      { val: 'intense', label: 'Intense' },
    ],
  },
  {
    key: 'alcoholIntake',
    label: 'Alcohol',
    icon: <AlcoholIcon />,
    options: [
      { val: 'none', label: 'None' },
      { val: 'some', label: 'Some' },
      { val: 'heavy', label: 'Heavy' },
    ],
  },
  {
    key: 'medicationTaken',
    label: 'Medication',
    icon: <MedIcon />,
    options: [
      { val: true, label: 'Yes' },
      { val: false, label: 'No' },
    ],
    isBoolean: true,
  },
];

const KNOWN_MEDICATIONS = [
  // Anti-diarrheals
  'Imodium', 'loperamide', 'Pepto-Bismol', 'bismuth subsalicylate',
  // Laxatives / fiber
  'Metamucil', 'psyllium', 'Miralax', 'polyethylene glycol', 'Colace', 'docusate',
  'Dulcolax', 'bisacodyl', 'senna', 'Senokot',
  // IBS-specific
  'Bentyl', 'dicyclomine', 'Linzess', 'linaclotide', 'Xifaxan', 'rifaximin',
  'Lotronex', 'alosetron', 'Amitiza', 'lubiprostone', 'Viberzi', 'eluxadoline',
  'hyoscyamine', 'Levsin',
  // Crohn's disease medications
  // - Aminosalicylates (5-ASA)
  'mesalamine', 'Asacol', 'Asacol HD', 'Pentasa', 'Lialda', 'Apriso', 'Delzicol',
  'sulfasalazine', 'Azulfidine', 'balsalazide', 'Colazal', 'olsalazine', 'Dipentum',
  // - Corticosteroids
  'prednisone', 'prednisolone', 'budesonide', 'Entocort EC', 'Uceris',
  'methylprednisolone', 'Medrol', 'hydrocortisone',
  // - Immunomodulators
  'azathioprine', 'Imuran', '6-mercaptopurine', '6-MP', 'Purinethol',
  'methotrexate', 'Trexall', 'cyclosporine', 'Sandimmune', 'Neoral',
  'tacrolimus', 'Prograf', 'mycophenolate', 'CellCept',
  // - Biologics (TNF inhibitors)
  'infliximab', 'Remicade', 'adalimumab', 'Humira', 'certolizumab pegol', 'Cimzia',
  'golimumab', 'Simponi',
  // - Biologics (integrin inhibitors)
  'vedolizumab', 'Entyvio', 'natalizumab', 'Tysabri',
  // - Biologics (IL-12/23 inhibitors)
  'ustekinumab', 'Stelara',
  // - Biologics (IL-23 inhibitors)
  'risankizumab', 'Skyrizi', 'guselkumab', 'Tremfya', 'mirikizumab', 'Omvoh',
  // - JAK inhibitors
  'tofacitinib', 'Xeljanz', 'upadacitinib', 'Rinvoq', 'filgotinib', 'Jyseleca',
  // - S1P receptor modulators
  'ozanimod', 'Zeposia', 'etrasimod', 'Velsipity',
  // Ulcerative colitis specific
  // - Rectal formulations
  'mesalamine suppository', 'Canasa', 'mesalamine enema', 'Rowasa',
  'hydrocortisone enema', 'Cortenema', 'budesonide foam', 'Uceris foam',
  // - UC-specific biologics/small molecules
  // (most listed above also apply to UC)
  // PPIs / antacids
  'omeprazole', 'Prilosec', 'pantoprazole', 'Protonix', 'esomeprazole', 'Nexium',
  'lansoprazole', 'Prevacid', 'famotidine', 'Pepcid', 'ranitidine',
  'Tums', 'calcium carbonate', 'Gaviscon',
  // Probiotics
  'probiotics', 'Align', 'Culturelle', 'Florastor', 'VSL#3', 'Bio-K',
  // Anti-spasmodics
  'peppermint oil', 'IBgard', 'buscopan', 'hyoscine',
  // NSAIDs (gut irritants)
  'ibuprofen', 'Advil', 'Motrin', 'naproxen', 'Aleve', 'aspirin',
  // Common OTC
  'Tylenol', 'acetaminophen', 'Benadryl', 'diphenhydramine',
  'Zyrtec', 'cetirizine', 'Claritin', 'loratadine', 'Allegra',
  // Antibiotics (common gut disruptors)
  'amoxicillin', 'azithromycin', 'ciprofloxacin', 'metronidazole', 'Flagyl',
  'doxycycline', 'clindamycin',
  // Supplements
  'fiber supplement', 'iron supplement', 'magnesium', 'vitamin D',
  'fish oil', 'omega-3', 'zinc', 'B12', 'multivitamin', 'calcium',
  'L-glutamine', 'turmeric', 'curcumin', 'slippery elm', 'aloe vera',
  // Antidepressants (often used for IBS/IBD)
  'amitriptyline', 'nortriptyline', 'sertraline', 'Zoloft', 'fluoxetine', 'Prozac',
  'duloxetine', 'Cymbalta', 'escitalopram', 'Lexapro',
  // Anti-nausea
  'Zofran', 'ondansetron', 'Dramamine', 'Gravol',
  // Anti-diarrheal (bile acid sequestrants)
  'cholestyramine', 'Questran', 'colesevelam', 'Welchol',
].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

function MedAutocomplete({ value, onChange }) {
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIdx, setSelectedIdx] = useState(-1);
  const [inputText, setInputText] = useState('');
  const [adding, setAdding] = useState(false);

  // Parse existing meds from comma-separated string
  const meds = (value || '').split(',').map(m => m.trim()).filter(Boolean);

  const handleInputChange = (text) => {
    setInputText(text);
    setSelectedIdx(-1);
    if (text.trim().length >= 2) {
      const lower = text.trim().toLowerCase();
      setSuggestions(
        KNOWN_MEDICATIONS.filter(m => m.toLowerCase().includes(lower) && !meds.map(x => x.toLowerCase()).includes(m.toLowerCase())).slice(0, 6)
      );
    } else {
      setSuggestions([]);
    }
  };

  const addMed = (med) => {
    const newMeds = [...meds, med];
    onChange(newMeds.join(', '));
    setInputText('');
    setSuggestions([]);
    setSelectedIdx(-1);
    setAdding(false);
  };

  const removeMed = (idx) => {
    const newMeds = meds.filter((_, i) => i !== idx);
    onChange(newMeds.join(', '));
    if (newMeds.length === 0) setAdding(true);
  };

  // Show input if no meds yet or actively adding
  const showInput = meds.length === 0 || adding;

  return (
    <div style={{ marginBottom: '14px' }}>
      {/* Medication chips */}
      {meds.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
          {meds.map((med, i) => (
            <span key={i} style={{
              display: 'inline-flex', alignItems: 'center', gap: '4px',
              background: '#F5EDE3', border: '1px solid #E8D9C8', borderRadius: '14px',
              padding: '4px 10px', fontSize: '13px', color: '#4A2E1F',
            }}>
              {med}
              <button
                onClick={() => removeMed(i)}
                style={{
                  background: 'none', border: 'none', color: '#7A5A44', cursor: 'pointer',
                  padding: '0 0 0 2px', fontSize: '14px', fontWeight: '700', lineHeight: 1, fontFamily: 'inherit',
                }}
              >x</button>
            </span>
          ))}
        </div>
      )}

      {/* Input field */}
      {showInput && (
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            className="input"
            placeholder={meds.length > 0 ? "Add another medication..." : "What medication? (e.g., Imodium, probiotics)"}
            value={inputText}
            onChange={e => handleInputChange(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'ArrowDown') { e.preventDefault(); setSelectedIdx(i => Math.min(i + 1, suggestions.length - 1)); }
              else if (e.key === 'ArrowUp') { e.preventDefault(); setSelectedIdx(i => Math.max(i - 1, -1)); }
              else if (e.key === 'Enter') {
                e.preventDefault();
                if (selectedIdx >= 0 && suggestions[selectedIdx]) {
                  addMed(suggestions[selectedIdx]);
                } else if (inputText.trim()) {
                  addMed(inputText.trim());
                }
              }
            }}
            onBlur={() => {
              setTimeout(() => {
                setSuggestions([]);
                if (!inputText.trim() && meds.length > 0) setAdding(false);
              }, 150);
            }}
            autoFocus={adding}
            autoComplete="off"
            style={{ fontSize: '14px', padding: '8px 12px' }}
          />
          {suggestions.length > 0 && (
            <div style={{
              position: 'absolute', top: '100%', left: 0, right: 0, background: 'white',
              border: '1px solid #E8D9C8', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              zIndex: 10, marginTop: '4px', overflow: 'hidden',
            }}>
              {suggestions.map((s, i) => (
                <button
                  key={s}
                  onMouseDown={e => { e.preventDefault(); addMed(s); }}
                  style={{
                    display: 'block', width: '100%', padding: '8px 12px', border: 'none',
                    background: i === selectedIdx ? '#f0edd4' : 'transparent', textAlign: 'left',
                    cursor: 'pointer', fontSize: '13px', color: '#4A2E1F', fontFamily: 'inherit',
                    borderBottom: i < suggestions.length - 1 ? '1px solid #f0edd4' : 'none',
                  }}
                >
                  {s}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Add button */}
      {meds.length > 0 && !adding && (
        <button
          onClick={() => setAdding(true)}
          style={{
            background: 'none', border: 'none', color: '#7E8B47', fontSize: '13px',
            fontWeight: '600', cursor: 'pointer', padding: '4px 0', fontFamily: 'inherit',
          }}
        >
          + Add another medication
        </button>
      )}
    </div>
  );
}

function DailyCheckin() {
  const [expanded, setExpanded] = useState(false);
  const [log, setLog] = useState({});
  const [showMore, setShowMore] = useState(false);
  const [medNotes, setMedNotes] = useState('');
  const [saveStatus, setSaveStatus] = useState(null); // null | 'saving' | 'saved'
  const saveTimerRef = useRef(null);
  const saveStatusTimerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const today = new Date().toISOString().split('T')[0];
    api.get(`/daily-log?date=${today}`).then(res => {
      if (!cancelled && res.data) {
        setLog(res.data);
        if (res.data.medicationNotes) setMedNotes(res.data.medicationNotes);
        // Auto-expand if they have data today
        const hasAnyData = res.data.stressLevel || res.data.sleepQuality || res.data.hydration ||
          res.data.exerciseLevel || res.data.alcoholIntake || res.data.medicationTaken != null;
        if (hasAnyData) setExpanded(true);
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const saveLog = (updatedLog) => {
    // Debounce saves
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    if (saveStatusTimerRef.current) clearTimeout(saveStatusTimerRef.current);
    setSaveStatus('saving');
    saveTimerRef.current = setTimeout(() => {
      const today = new Date().toISOString().split('T')[0];
      api.post('/daily-log', { ...updatedLog, date: today }).then(() => {
        setSaveStatus('saved');
        saveStatusTimerRef.current = setTimeout(() => setSaveStatus(null), 2000);
      }).catch(err => {
        console.error('Failed to save daily log:', err);
        setSaveStatus(null);
      });
    }, 300);
  };

  const handleSelect = (key, value, isBoolean) => {
    setLog(prev => {
      const currentVal = isBoolean ? prev[key] : prev[key];
      // Toggle off if same value
      const newVal = currentVal === value ? null : value;
      const updated = { ...prev, [key]: newVal };
      saveLog(updated);
      return updated;
    });
  };

  const handleMedNotes = (text) => {
    setMedNotes(text);
    setLog(prev => {
      const updated = { ...prev, medicationNotes: text };
      saveLog(updated);
      return updated;
    });
  };

  const handleMenstrual = (val) => {
    setLog(prev => {
      const newVal = prev.menstrualCycle === val ? null : val;
      const updated = { ...prev, menstrualCycle: newVal };
      saveLog(updated);
      return updated;
    });
  };

  return (
    <div className="card" style={{
      padding: expanded ? '20px' : '16px 20px',
      border: '2px solid #7E8B47',
      background: expanded ? undefined : 'linear-gradient(135deg, #f7f5e8 0%, #ffffff 100%)',
    }}>
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer',
          marginBottom: expanded ? '16px' : 0,
        }}
      >
        {!expanded && (
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7E8B47" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
            <path d="M9 12h6M12 9v6"/>
          </svg>
        )}
        <div style={{ flex: 1 }}>
          <span style={{ fontSize: expanded ? '17px' : '16px', fontWeight: '700', color: '#4A2E1F', display: 'block' }}>
            Daily Check-in
          </span>
          {!expanded && (
            <span style={{ fontSize: '13px', color: '#7A5A44', opacity: 0.7 }}>
              Stress, sleep, exercise &amp; more — helps find your triggers
            </span>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {expanded && saveStatus && (
            <span style={{
              fontSize: '12px',
              fontWeight: 600,
              color: saveStatus === 'saved' ? '#7E8B47' : '#7A5A44',
              opacity: saveStatus === 'saved' ? 1 : 0.5,
              transition: 'opacity 0.3s ease',
            }}>
              {saveStatus === 'saving' ? 'Saving…' : '✓ Saved'}
            </span>
          )}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7E8B47" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            style={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s ease' }}>
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </div>
      </div>

      {expanded && (
        <>

      {CHECKIN_SECTIONS.map(section => (
        <div key={section.key} style={{ marginBottom: '14px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
            {section.icon}
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#4A2E1F' }}>{section.label}</span>
          </div>
          <div className="symptom-chips">
            {section.options.map(opt => {
              const isActive = section.isBoolean
                ? log[section.key] === opt.val
                : log[section.key] === opt.val;
              return (
                <button
                  key={String(opt.val)}
                  className={`symptom-chip${isActive ? ' active' : ''}`}
                  onClick={() => handleSelect(section.key, opt.val, section.isBoolean)}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {/* Medication notes with autocomplete (shown when medication = yes) */}
      {log.medicationTaken === true && (
        <MedAutocomplete value={medNotes} onChange={handleMedNotes} />
      )}

      {/* Show more options */}
      {!showMore ? (
        <button
          onClick={() => setShowMore(true)}
          style={{
            background: 'none', border: 'none', color: '#7E8B47', cursor: 'pointer',
            fontSize: '13px', fontWeight: '600', padding: '4px 0', fontFamily: 'inherit'
          }}
        >
          Show more options
        </button>
      ) : (
        <div style={{ marginBottom: '14px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#4A2E1F' }}>Menstrual cycle</span>
          </div>
          <div className="symptom-chips">
            <button
              className={`symptom-chip${log.menstrualCycle === true ? ' active' : ''}`}
              onClick={() => handleMenstrual(true)}
            >
              Yes
            </button>
            <button
              className={`symptom-chip${log.menstrualCycle === false ? ' active' : ''}`}
              onClick={() => handleMenstrual(false)}
            >
              No
            </button>
          </div>
        </div>
      )}
      </>)}
    </div>
  );
}

function Home() {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const [toastMessage, setToastMessage] = useState('Logged!');
  const [loading, setLoading] = useState(false);
  const [showSeverityPicker, setShowSeverityPicker] = useState(false);
  const [selectedSeverity, setSelectedSeverity] = useState(null);
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [selectedBloodLevel, setSelectedBloodLevel] = useState('none');
  const [useCustomTime, setUseCustomTime] = useState(false);
  const [customDatetime, setCustomDatetime] = useState(getNowDatetimeLocal());
  const [summaryKey, setSummaryKey] = useState(0);
  const [mealRecap, setMealRecap] = useState(null); // { meals: [], severity, isBad }

  const toggleSymptom = (symptom) => {
    setSelectedSymptoms(prev =>
      prev.includes(symptom)
        ? prev.filter(s => s !== symptom)
        : [...prev, symptom]
    );
  };

  const handleSeverityPick = (sev) => {
    setSelectedSeverity(sev);
  };

  const handleLogPoop = async () => {
    setLoading(true);
    setShowSeverityPicker(false);
    try {
      const timestamp = useCustomTime ? new Date(customDatetime).toISOString() : undefined;
      const bloodLevel = selectedBloodLevel !== 'none' ? selectedBloodLevel : undefined;
      await offlinePost('/poops', {
        severity: selectedSeverity,
        symptoms: selectedSymptoms.length > 0 ? selectedSymptoms : undefined,
        timestamp,
        bloodLevel
      });
      setSelectedSeverity(null);
      setSelectedSymptoms([]);
      setSelectedBloodLevel('none');
      setUseCustomTime(false);
      setCustomDatetime(getNowDatetimeLocal());
      setSummaryKey(k => k + 1); // refresh summary
      trackEvent('poop_logged');

      // Fetch meal recap (what you ate in the 6-36h window before this poop)
      const poopTime = useCustomTime ? new Date(customDatetime).getTime() : Date.now();
      const isBad = ['6', '7', '1', '2', 'severe'].includes(selectedSeverity);
      const recapSeverity = selectedSeverity;

      const fetchRecapMeals = async () => {
        try {
          let allMeals = [];
          const res = await api.get('/meals');
          allMeals = Array.isArray(res.data) ? res.data : (res.data.meals || []);
          const windowStart = poopTime - 36 * 3600 * 1000;
          const windowEnd = poopTime - 6 * 3600 * 1000;
          const recentMeals = allMeals
            .filter(m => {
              const t = new Date(m.timestamp).getTime();
              return t >= windowStart && t <= windowEnd;
            })
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .slice(0, 8);

          if (recentMeals.length > 0) {
            setMealRecap({ meals: recentMeals, severity: recapSeverity, isBad, poopTime });
          }
        } catch (err) {
          console.error('Failed to fetch meal recap:', err);
        }
      };
      fetchRecapMeals();

      fetchInsightProgress().then(({ mealsCount, poopsCount, daysCovered, hasAnalyzed }) => {
        const msg = getProgressMessage('poop', { mealsCount, poopsCount, daysCovered }, hasAnalyzed);
        setToastMessage(msg || 'Logged!');
        setShowSuccess(true);
        const duration = msg ? 3500 : 2000;
        setTimeout(() => setShowSuccess(false), duration);
      }).catch(() => {
        setToastMessage('Logged!');
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2000);
      });
    } catch (error) {
      console.error('Failed to log poop:', error);
      alert('Failed to log. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      {showSuccess && (
        <div
          className="success-flash"
          style={toastMessage !== 'Logged!' ? { animationDuration: '3.5s', cursor: 'pointer' } : undefined}
          onClick={toastMessage.includes('Insights') ? () => navigate('/insights') : undefined}
        >
          {toastMessage}
        </div>
      )}

      {/* Meal Recap Card — shows after logging a poop */}
      {mealRecap && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.4)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '20px',
        }} onClick={() => setMealRecap(null)}>
          <div style={{
            background: '#FFFDF8', borderRadius: '20px', padding: '24px',
            maxWidth: '380px', width: '100%', maxHeight: '80vh', overflowY: 'auto',
            boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
          }} onClick={e => e.stopPropagation()}>
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <span style={{ fontSize: '32px' }}>{mealRecap.isBad ? '🔍' : '📋'}</span>
              <h3 style={{
                margin: '8px 0 4px', fontSize: '18px', fontWeight: '700', color: '#4A2E1F',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}>
                {mealRecap.isBad ? 'What might have caused this?' : 'What you ate beforehand'}
              </h3>
              <p style={{ margin: 0, fontSize: '13px', color: '#7A5A44' }}>
                Meals in the 6–36 hour window before this BM
              </p>
            </div>

            {mealRecap.meals.map((meal, i) => {
              const hoursAgo = Math.round((mealRecap.poopTime - new Date(meal.timestamp).getTime()) / 3600000);
              const foods = meal.foods || [];
              const mealName = foods.map(f => f.name).join(', ') || 'Meal';
              return (
                <div key={meal.id || i} style={{
                  padding: '12px', marginBottom: '8px',
                  background: mealRecap.isBad ? '#FFF8F6' : '#F7F5E8',
                  borderRadius: '12px',
                  border: `1px solid ${mealRecap.isBad ? '#F0D6D0' : '#E8E0C8'}`,
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <span style={{ fontWeight: '600', fontSize: '15px', color: '#4A2E1F', flex: 1 }}>
                      {mealName}
                    </span>
                    <span style={{
                      fontSize: '12px', color: '#7A5A44', whiteSpace: 'nowrap', marginLeft: '8px',
                      background: '#EDE8E0', padding: '2px 8px', borderRadius: '10px',
                    }}>
                      {hoursAgo}h ago
                    </span>
                  </div>
                  {foods.length > 0 && foods[0].ingredients && (() => {
                    let ings = [];
                    try {
                      ings = typeof foods[0].ingredients === 'string'
                        ? JSON.parse(foods[0].ingredients) : foods[0].ingredients;
                    } catch(e) { ings = []; }
                    if (!Array.isArray(ings) || ings.length === 0) return null;
                    return (
                      <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#7A5A44' }}>
                        {ings.slice(0, 6).join(', ')}{ings.length > 6 ? '…' : ''}
                      </p>
                    );
                  })()}
                </div>
              );
            })}

            {mealRecap.isBad && (
              <p style={{
                margin: '12px 0 0', fontSize: '13px', color: '#7A5A44', textAlign: 'center',
                lineHeight: '1.4',
              }}>
                Keep logging — the more data you track, the better we can pinpoint your triggers.
              </p>
            )}

            <button
              onClick={() => setMealRecap(null)}
              style={{
                display: 'block', width: '100%', marginTop: '16px',
                padding: '12px', background: '#7E8B47', color: '#fff',
                border: 'none', borderRadius: '12px', fontSize: '15px',
                fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}

      <div className="page-header" style={{ textAlign: 'center', position: 'relative' }}>
        <button
          onClick={() => navigate('/settings')}
          style={{
            position: 'absolute',
            top: '24px',
            right: '0',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px 8px',
            lineHeight: 1
          }}
          aria-label="Settings"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4A2E1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.45 }}>
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        </button>
        <h1 className="page-title" style={{ fontSize: '26px', lineHeight: 1.2, margin: '16px 0 0' }}>
          How's your gut today?
        </h1>
      </div>

      <div className="container" style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'center', paddingBottom: '80px' }}>
        <DailySummary key={summaryKey} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <button className="btn btn-primary" onClick={() => navigate('/log-meal')}>
            <MealIcon />
            Log Meal
          </button>

          {!showSeverityPicker ? (
            <button
              className="btn btn-secondary"
              onClick={() => setShowSeverityPicker(true)}
              disabled={loading}
            >
              {loading ? <span className="btn-spinner" /> : <PoopIcon />}
              {loading ? 'Logging...' : 'Log Poop'}
            </button>
          ) : (
            <div className="card" style={{ padding: '24px' }}>
              <p style={{ margin: '0 0 4px 0', fontWeight: '700', textAlign: 'center', fontSize: '20px', color: '#4A2E1F' }}>
                How was it?
              </p>
              <p style={{ margin: '0 0 16px 0', fontSize: '12px', textAlign: 'center', color: '#7A5A44', opacity: 0.7 }}>
                Bristol Stool Scale
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px' }}>
                {BRISTOL_TYPES.map(t => (
                  <button
                    key={t.val}
                    onClick={() => handleSeverityPick(t.val)}
                    style={{
                      width: 'calc(25% - 6px)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '2px',
                      padding: '8px 2px 6px',
                      border: selectedSeverity === t.val ? '2px solid #4A2E1F' : '2px solid #E8D5C0',
                      borderRadius: '12px',
                      background: selectedSeverity === t.val ? '#F5E6D3' : '#FFF',
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                    }}
                  >
                    <span style={{ fontSize: '10px', fontWeight: '700', color: '#4A2E1F', opacity: 0.5 }}>{t.val}</span>
                    {BRISTOL_ICONS[t.val]}
                    <span style={{ fontSize: '10px', fontWeight: '600', color: '#4A2E1F', lineHeight: 1.2, textAlign: 'center' }}>{t.label}</span>
                  </button>
                ))}
              </div>

              {/* Blood Level Slider */}
              <p style={{ margin: '20px 0 8px 0', fontWeight: '600', textAlign: 'center', fontSize: '15px', color: '#7A5A44' }}>
                Blood?
              </p>
              <div style={{ padding: '0 8px' }}>
                <input
                  type="range"
                  min="0"
                  max="3"
                  value={BLOOD_LEVELS.findIndex(b => b.val === selectedBloodLevel)}
                  onChange={e => setSelectedBloodLevel(BLOOD_LEVELS[parseInt(e.target.value)].val)}
                  style={{
                    width: '100%',
                    height: '6px',
                    borderRadius: '3px',
                    outline: 'none',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    background: `linear-gradient(to right, #C8D4A0 0%, #E8C47A 33%, #D4846A 66%, #B8564A 100%)`,
                    cursor: 'pointer',
                  }}
                />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                  {BLOOD_LEVELS.map((b, i) => (
                    <span
                      key={b.val}
                      onClick={() => setSelectedBloodLevel(b.val)}
                      style={{
                        fontSize: '11px',
                        fontWeight: selectedBloodLevel === b.val ? '700' : '400',
                        color: selectedBloodLevel === b.val
                          ? (i === 0 ? '#7E8B47' : i === 1 ? '#B8964A' : i === 2 ? '#C4683C' : '#B8564A')
                          : '#7A5A44',
                        cursor: 'pointer',
                        opacity: selectedBloodLevel === b.val ? 1 : 0.5,
                        textAlign: i === 0 ? 'left' : i === 3 ? 'right' : 'center',
                        flex: 1,
                      }}
                    >
                      {b.val !== 'none' && selectedBloodLevel === b.val ? '● ' : ''}{b.label}
                    </span>
                  ))}
                </div>
              </div>

              {/* Symptoms */}
              <p style={{ margin: '20px 0 12px 0', fontWeight: '600', textAlign: 'center', fontSize: '15px', color: '#7A5A44' }}>
                Any symptoms?
              </p>
              <div className="symptom-chips">
                {SYMPTOM_OPTIONS.map(s => (
                  <button
                    key={s.val}
                    className={`symptom-chip${selectedSymptoms.includes(s.val) ? ' active' : ''}`}
                    onClick={() => toggleSymptom(s.val)}
                  >
                    <span style={{ display: 'flex', alignItems: 'center' }}>{SymptomIcons[s.val]}</span> {s.label}
                  </button>
                ))}
              </div>

              {/* Custom Timestamp */}
              <div style={{ marginTop: '16px', textAlign: 'center' }}>
                {!useCustomTime ? (
                  <button
                    onClick={() => setUseCustomTime(true)}
                    style={{
                      background: '#f7f5e8',
                      border: '1px solid #d4cfb8',
                      borderRadius: '10px',
                      color: '#4A2E1F',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      padding: '10px 16px',
                      fontFamily: 'inherit',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7E8B47" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                    </svg>
                    Log for a different time
                  </button>
                ) : (
                  <div style={{ textAlign: 'left' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                      <label style={{ fontSize: '14px', fontWeight: '700', color: '#4A2E1F' }}>When did this happen?</label>
                      <button
                        onClick={() => { setUseCustomTime(false); setCustomDatetime(getNowDatetimeLocal()); }}
                        style={{ background: 'none', border: 'none', color: '#7A5A44', fontSize: '13px', cursor: 'pointer', fontFamily: 'inherit' }}
                      >
                        Use current time
                      </button>
                    </div>
                    <input
                      type="datetime-local"
                      className="input"
                      value={customDatetime}
                      onChange={(e) => setCustomDatetime(e.target.value)}
                      max={getNowDatetimeLocal()}
                    />
                  </div>
                )}
              </div>

              <button
                className="btn btn-primary"
                style={{ marginTop: '16px', height: '52px', fontSize: '18px', borderRadius: '16px' }}
                onClick={handleLogPoop}
                disabled={loading || !selectedSeverity}
              >
                {loading ? <><span className="btn-spinner" /> Logging...</> : 'Log It'}
              </button>
            </div>
          )}
        </div>

          <div style={{ marginTop: '48px' }}>
            <DailyCheckin />
          </div>
      </div>
    </div>
  );
}

export default Home;
